import WorkbookTemplateWrapperV2 from "./WorkbookTemplateWrapperV2";
export default WorkbookTemplateWrapperV2;
